import { persistReducer } from 'redux-persist';
import { createReducer } from '@/redux/lib/createReducer.js';
import buildPersistConfig from '@/redux/lib/buildPersistConfig.js';

const createPersistedReducer = (initialState, reducerMap, persistConfig) => {
  const reducer = createReducer(initialState, reducerMap);

  return persistReducer(buildPersistConfig(persistConfig.key, persistConfig), reducer);
};

export default createPersistedReducer;
